
import { Browse } from "@/models/browse";
import { AuthService, BrowseService, DossierService, ViewService } from "@/services";
import AppBrowse from "./UsersShareViewsBrowse.vue";
import Vue from "vue";
import { UserInfo } from "@/models/dossier/user-info";

export default Vue.extend({
	data(){
		return {
			step: 0,
			selectedViews: [] as number[],
			browses: [] as Browse[],
			users: [] as UserInfo[],
			selectedUsers: [] as number[],
			saving: false
		};
	},
	methods: {
		async fetch(){
			let browses = await BrowseService.getBrowses();
			let views = await ViewService.getUsersViews(AuthService.wfUser.ID);
			browses.forEach(b=>
				b.Views = views.filter(v=>v.BrowseID == b.ID)
			);
			this.browses = browses;
			let users = await DossierService.getUsers();
			let i = users.findIndex(u=>u.ID == AuthService.wfUser.ID);
			if (i != -1) {
				users.splice(i, 1);
			}
			this.users = users;
		},
		close(){
			this.$emit("close");
		},
		isUserSelected(user:UserInfo):boolean {
			return this.selectedUsers.indexOf(user.ID) != -1;
		},
		selectUser(user:UserInfo, value:boolean) {
			if (this.isUserSelected(user) == value) return;
			if (value) {
				this.selectedUsers.push(user.ID);
			}else{
				let i = this.selectedUsers.indexOf(user.ID);
				this.selectedUsers.splice(i,1);
			}
		},
		async confirm(){
			if (this.saving) return;
			try{
				this.saving = true;
				let views = this.selectedViews;
				let users = this.selectedUsers;
				for (let view of views){
					await ViewService.setShares(view, users, []);
				}
				let message = this.$ct("views-have-been-shared");
				this.$wf.notify(message, "success", 3000, "check");
				this.close();
			}catch(err){

			}finally{
				this.saving = false;
			}
		}
	},
	async created(){
		await this.fetch();
	},
	components: {
		AppBrowse
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
